import TfaResetProcess from "../pages/auth/TfaResetProcess";
var routes = [{
  path: '/',
  name: 'publicRoot',
  component: function component() {
    return import('layouts/DefaultPublic');
  },
  meta: {
    auth: false,
    title: 'verifynest | Home'
  },
  children: [{
    name: 'publicHome',
    path: '/home',
    component: function component() {
      return import('pages/Home');
    },
    meta: {
      title: 'verifynest | Home'
    }
  }, // register
  {
    name: 'register',
    path: '/register',
    component: function component() {
      return import('pages/auth/Register');
    },
    meta: {
      title: 'verifynest | Register'
    }
  }, // signin
  {
    name: 'signin',
    path: '/signin',
    component: function component() {
      return import('pages/auth/SignIn');
    },
    meta: {
      title: 'verifynest | Sign In'
    }
  }, // verify email
  {
    name: 'verify-email',
    path: '/verify/email/:code?',
    component: function component() {
      return import('pages/auth/VerifyEmail');
    },
    meta: {
      title: 'verifynest | Verify Email'
    }
  }, // verify email via invite
  {
    name: 'verifyemail-invite',
    path: '/verifyinvite/:code?',
    component: function component() {
      return import('pages/auth/VerifyEmailInvite');
    },
    meta: {
      title: 'verifynest | Verify Email'
    }
  }, // password reset request
  {
    name: 'password-reset-request',
    path: '/password/reset/request',
    component: function component() {
      return import('pages/auth/PasswordResetRequest');
    },
    meta: {
      title: 'verifynest | Password Reset Request'
    }
  }, // password reset process
  {
    name: 'password-reset-process',
    path: '/password/reset/process/:code',
    component: function component() {
      return import('pages/auth/PasswordResetProcess');
    },
    meta: {
      title: 'verifynest | Password Reset Process'
    }
  },
  /*
  TFA
  */
  // setup
  {
    name: 'tfa-setup',
    path: '/tfa/setup',
    component: function component() {
      return import('pages/auth/TfaSetup');
    },
    meta: {
      title: 'verifynest | Two-Factor Authentication Setup',
      auth: true
    }
  }, // google
  {
    name: 'tfa-google',
    path: '/tfa/google',
    component: function component() {
      return import('pages/auth/TfaGoogle');
    },
    meta: {
      title: 'verifynest | Two-Factor Authentication',
      auth: true
    }
  }, // sms
  {
    name: 'tfa-sms',
    path: '/tfa/sms',
    component: function component() {
      return import('pages/auth/TfaSms');
    },
    meta: {
      title: 'verifynest | Two-Factor Authentication',
      auth: true
    }
  }, // reset
  {
    name: 'tfa-reset-process',
    path: '/tfa/reset/process/:code',
    component: TfaResetProcess,
    meta: {
      title: 'verifynest | Two-Factor Authentication Reset'
    }
  },
  /*
  ERROR 401
  */
  {
    name: 'error401',
    path: '/error401',
    component: function component() {
      return import('pages/Error401');
    },
    meta: {
      title: 'verifynest | Permission Error'
    }
  }]
}, {
  path: '/app',
  component: function component() {
    return import('layouts/Default');
  },
  meta: {
    auth: true
  },
  children: [
  /*
   DASHBOARD
   */
  {
    name: 'dashboard',
    path: '/dashboard',
    component: function component() {
      return import('pages/Dashboard');
    },
    meta: {
      auth: true,
      title: 'verifynest | Dashboard'
    }
  },
  /*
   PROFILE
   */
  {
    name: 'profile',
    path: '/profile',
    component: function component() {
      return import('pages/auth/Profile');
    },
    meta: {
      auth: true,
      title: 'verifynest | Profile'
    }
  },
  /*
  TEAMS
  */
  // team setup
  {
    name: 'team-setup',
    path: '/team/setup',
    component: function component() {
      return import('pages/auth/TeamSetup');
    },
    meta: {
      title: 'verifynest | Team Setup',
      auth: true
    }
  }, // home
  {
    name: 'team-home',
    path: '/team',
    component: function component() {
      return import('pages/team/TeamHome');
    },
    meta: {
      auth: true,
      title: 'verifynest | Team'
    },
    children: [// users
    {
      name: 'team-users',
      path: '/team/users',
      component: function component() {
        return import('pages/team/TeamUserManagement');
      },
      meta: {
        auth: true,
        title: 'verifynest | Users'
      }
    }, // notification
    {
      name: 'team-notifications',
      path: '/team/notifications',
      component: function component() {
        return import('pages/team/TeamNotifications');
      },
      meta: {
        auth: true,
        title: 'verifynest | Notifications'
      }
    }, // sms
    {
      name: 'team-sms',
      path: '/team/sms',
      component: function component() {
        return import('pages/team/TeamSms');
      },
      meta: {
        auth: true,
        title: 'verifynest | SMS'
      }
    }]
  }]
},
/*
Privacy Policy
*/
{
  name: 'privacy-policy',
  path: '/privacy-policy',
  component: function component() {
    return import('pages/PrivacyPolicy');
  },
  meta: {
    title: 'verifynest | Privacy Policy'
  }
},
/*
Terms & Conditions
*/
{
  name: 'terms-and-conditions',
  path: '/terms-and-conditions',
  component: function component() {
    return import('pages/TermsAndConditions');
  },
  meta: {
    title: 'verifynest | Terms & Conditions'
  }
},
/*
ERROR `404`
*/
{
  name: 'error404',
  path: '*',
  component: function component() {
    return import('pages/Error404');
  },
  meta: {
    title: 'verifynest | Page Not Found'
  }
}];
export default routes;